<script>
import {
  defineComponent,
  ref,
  reactive,
  onBeforeUnmount,
  onMounted,
} from "vue";
import Swal from "sweetalert2";
import visits from "@/visits/composables/useVisits";
import formatDateWithHours from "@/helpers/formatDateWithHours";
//import { useRoute } from "vue-router";
export default defineComponent({
  name: "visitDetails",
  emits: ["reloadTable"],
  setup(props, { emit }) {
    const {
      visitDetails,
      CheckOutVisit,
      seeImagesfromBack,
      deleteImageFromBack,
    } = visits();
    const isOpenClose = ref(false);
    const details = ref([]);
    const tipo = ref("");
    const id_p_visita = ref("");
    const observacionesSalida = ref("");
    const obs_salida = ref(null);
    const imagenes = ref([]);
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });
    const formData = reactive({
      picture: "",
    });
    const showModal = async (val) => {
      const { dialog, id_visita, id_persona_visita, state } = val;
      isOpenClose.value = dialog;
      tipo.value = state;
      id_p_visita.value = id_persona_visita;
      const { data } = await visitDetails(id_visita);
      details.value = await data.respuesta;
      if (data.images.length > 0) {
        await seeImages(data.images);
      }
      tipo.value === "active" ? obs_salida.value.focus() : "";
    };
    const OpenCloseModal = () => {
      isOpenClose.value = false;
      imagenes.value = [];
    };
    const formatDateAndHours = (date) => {
      if (date === null) {
        return "-.-";
      } else {
        const formattedDate = formatDateWithHours(date);
        return formattedDate;
      }
    };
    const seeImages = async (values) => {
      for await (const value of values) {
        const r = await seeImagesfromBack(value.id_img_visita);
        imagenes.value.push({ id: value.id_img_visita, image: r });
      }
    };
    const registerCheckOutVisit = async () => {
      const { data } = await CheckOutVisit({
        observacion: observacionesSalida,
        id_persona_visita: id_p_visita,
      });
      if (data.ok) {
        Swal.fire(
          "Salida Registrada",
          `Registro de salida de visita realizado exitosamente`,
          "success"
        );
        observacionesSalida.value = "";
        isOpenClose.value = false;
        emit("reloadTable", "inactive");
      } else {
        Swal.fire(
          "Salida no Registrada",
          `Error al realizar el registro`,
          "error"
        );
      }
      imagenes.value = [];
    };
    const deleteImage = async (val) => {
      const { data } = await deleteImageFromBack(val);
      if (data.ok) {
        Toast.fire({
          icon: "success",
          title: `Imagen eliminada exitosamente`,
        });
      } else {
        Toast.fire({
          icon: "error",
          title: `No se pudo eliminar la imagen`,
        });
      }
      await OpenCloseModal();
    };
    const screenWidth = ref(window.innerWidth);
    const updateScreenWidth = () => {
      screenWidth.value = window.innerWidth;
    };
    onMounted(() => {
      window.addEventListener("resize", updateScreenWidth);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", updateScreenWidth);
    });
    return {
      formData,
      showModal,
      isOpenClose,
      OpenCloseModal,
      details,
      tipo,
      formatDateAndHours,
      observacionesSalida,
      registerCheckOutVisit,
      id_p_visita,
      obs_salida,
      imagenes,
      seeImages,
      screenWidth,
      updateScreenWidth,
      deleteImage,
    };
  },
  directives: {
    // transform input to uppercase with v-uppercase
    uppercase: {
      updated: function (el) {
        el.value = el.value.toUpperCase();
        el.dispatchEvent(new Event("input"));
      },
    },
  },
});
</script>
<template>
  <div>
    <!-- Modal -->
    <div
      v-if="isOpenClose"
      class="modal fade show"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
      style="display: block"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4>
              {{
                tipo === "active"
                  ? "Registro de Salida"
                  : "Detalles de la Visita"
              }}
            </h4>
            <button
              type="button"
              @click="OpenCloseModal()"
              class="btn-close"
            ></button>
          </div>
          <div class="modal-body">
            <!--begin::Input group-->
            <div class="row">
              <!-- datos personales visita -->
              <div class="col-md-5">
                <div style="text-align: center">
                  <img
                    :src="`${details.visita_imagen_segip}`"
                    class="rounded-circle"
                    width="120"
                    height="120"
                  />
                </div>
                <p style="text-align: center">
                  {{ details.nombre_visita }}
                  <br />
                  {{ details.visita_numero_documento }}
                  <br />
                  <strong
                    >N° {{ details.nombre_tipo_documento_identidad }}</strong
                  ><br />
                  {{ details.visita_telefono_movil }}<br />
                  <strong>N° CONTACTO</strong>
                </p>
              </div>
              <!-- datos generales de la visita -->
              <div class="col-md-7 mt-5 border border-4">
                <table>
                  <tr v-if="details.tipo_visita === 'PERSONAL'">
                    <th>NOMBRE PPL:</th>
                    <td>{{ details.nombre_ppl }}</td>
                  </tr>
                  <tr>
                    <th>FECHA DE INGRESO :</th>
                    <td>
                      {{ formatDateAndHours(details.fecha_visita_ingreso) }}
                    </td>
                  </tr>
                  <tr v-if="tipo !== 'active'">
                    <th>FECHA DE SALIDA :</th>
                    <td>
                      {{ formatDateAndHours(details.fecha_visita_salida) }}
                    </td>
                  </tr>
                  <tr>
                    <th>RECINTO :</th>
                    <td>{{ details.nombre_recinto_penitenciario }}</td>
                  </tr>
                  <tr v-if="details.tipo_visita === 'PERSONAL'">
                    <th>SECCIÓN:</th>
                    <td>{{ details.nombre_seccion }}</td>
                  </tr>
                  <tr>
                    <th>MOTIVO DE VISITA:</th>
                    <td>{{ details.motivo_visita }}</td>
                  </tr>
                  <tr>
                    <th>TIPO DE VISITA:</th>
                    <td>{{ details.tipo_visita }}</td>
                  </tr>
                  <tr v-if="details.tipo_visita === 'PERSONAL'">
                    <th>PARENTESCO:</th>
                    <td>{{ details.nombre_parentesco }}</td>
                  </tr>
                  <template
                    v-if="
                      details.tipo_visita === 'INSTITUCIONAL' ||
                      details.nombre_parentesco === 'OTRO'
                    "
                  >
                    <tr>
                      <th>
                        {{
                          details.tipo_visita === "INSTITUCIONAL"
                            ? "CARGO"
                            : "RELACIÓN"
                        }}:
                      </th>
                      <td>{{ details.relacion }}</td>
                    </tr>
                    <tr>
                      <th>INSTITUCIÓN:</th>
                      <td>{{ details.institucion }}</td>
                    </tr>
                  </template>
                  <tr>
                    <th>OBSERVACIONES INGRESO:</th>
                    <td>{{ details.observaciones_ingreso }}</td>
                  </tr>
                  <tr v-if="tipo !== 'active'">
                    <th>OBSERVACIONES SALIDA:</th>
                    <td>{{ details.observaciones }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <!-- PARA FOTOS AÑADIDAS -->
            <div class="row m-3">
              <template v-for="(val, index) in imagenes" :key="index">
                <div
                  :class="
                    screenWidth > '990'
                      ? 'col-md-4 '
                      : screenWidth > '767'
                      ? 'col-md-6'
                      : 'col-md-4'
                  "
                >
                  <img
                    :src="val.image"
                    class="rounded mt-2 mb-2"
                    :width="
                      screenWidth > '990'
                        ? '230'
                        : screenWidth > '767'
                        ? '200'
                        : '350'
                    "
                    :height="
                      screenWidth > '990'
                        ? '230'
                        : screenWidth > '767'
                        ? '200'
                        : '300'
                    "
                  />
                  <div class="d-flex justify-content-center">
                    <button
                      class="btn btn-warning btn-sm p-2"
                      @click="deleteImage(val.id)"
                    >
                      Eliminar Imagen
                    </button>
                  </div>
                </div>
              </template>
            </div>
            <!-- observaciones -->
            <div v-if="tipo === 'active'" class="row">
              <label class="form-label">Observaciones Salida :</label>
              <textarea
                type="text"
                class="form-control fuente"
                v-uppercase
                id="obs_salida"
                ref="obs_salida"
                v-model.trim="observacionesSalida"
              />
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <!-- btn Guardar -->
            <div>
              <button
                v-if="tipo === 'active'"
                type="button"
                class="btn btn-primary"
                @click="registerCheckOutVisit()"
              >
                Registrar Salida
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
